export default {
      id: "logo-facebook-usage",
      viewBox: "0 0 320 512",
      url: __webpack_public_path__ + "mysource_files/sprite-map.svg#logo-facebook",
      toString: function () {
        return this.url;
      }
    }